import React, { useState } from "react";
import { UseFormGetValues } from 'react-hook-form';
import { ImageUploader } from "../ImageUploader";
import { Input } from "../Input";
import { Select } from "../Select";

type GovernmentIdUploadProps = {
  tabName: string;
  theme: any;
  handleFileChange: (tabName: string, state: any) => void;
  label?: string;
  register?: any;
  requiredField: string[];
  errors: any;
  getValues:  UseFormGetValues<any>;
};

const GovernmentIdUpload = ({
  tabName,
  theme,
  handleFileChange,
  label,
  requiredField,
  register,
  errors,
  getValues,
}: GovernmentIdUploadProps) => {
  const [state, setState] = useState<any>({ name: "governmentId" });
  const [image, setImage] = useState("");

  const options = [
    {
      id: 'driver_license',
      option: "Driver's Licence"
    },
    {
      id: 'voter_card',
      option: "Voter's Card"
    },
    {
      id: 'international_passport',
      option: "International Passport"
    },
    {
      id: 'national_id',
      option: "National ID Card"
    },
  ]
  
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    tabName: string
  ) => {
    const { value, name } = e.target;
    setState((prev: any) => {
      return { ...prev, [name]: value };
    });
    handleFileChange(tabName, { ...state, [name]: value });
  };
  function handleImageChange(e: React.ChangeEvent<any>) {
    const { validity, files } = e.target;
    const file = files[0];
    const reader = new FileReader();
    if (file) {
      setImage(URL.createObjectURL(file));
      reader.readAsDataURL(file);
      reader.onload = () => {
        setState((prev: any) => {
          return { ...prev, fileDetails: { file, validity: validity.valid } };
        });
        handleFileChange(tabName, {
          ...state,
          fileDetails: { file, validity: validity.valid },
        });
      };
    }
  }

  return (
    <>
      <ImageUploader
        change={handleImageChange}
        image={image}
        type={"file"}
        name={"governmentId"}
        required={requiredField.includes("governmentId")}
        register={register}
        errors={errors}
        label={label}
      />
      <Select
        name={"documentName"}
        theme={theme}
        required={requiredField.includes("documentName")}
        register={register}
        errors={errors}
        options={options}
        instruction={"Document Name"}
        changeFile={handleChange}
        tabName={tabName}
        state={state}
        getValues={getValues}
      />
      <Input
        name="documentNumber"
        placeholder="ID Number"
        type="text"
        theme={theme}
        required={requiredField.includes("documentNumber")}
        change={(e: any) => handleChange(e, tabName)}
        register={register}
        errors={errors}
        changeFile={handleChange}
        tabName={tabName}
        state={state}
      />
    </>
  );
};

export default GovernmentIdUpload;
